<template>
  <div class="wrapper" v-if="!fetching || data.length">
    <el-card class="wrap-tree" shadow="never">
      <div slot="header">系统菜单</div>
      <el-tree
        highlight-current
        :expand-on-click-node="false"
        class="tree"
        :data="data"
        :props="defaultProps"
        node-key="id"
        :default-expanded-keys="defaultExpandedKeys"
        @node-click="handleNodeClick"
      >
        <span class="custom-tree-node" slot-scope="{node, data}">
          <icon-svg class="tree-node-icon" v-if="node.level === 2 && data.icon" :icon-class="data.icon"></icon-svg>
          <span class="custom-tree-node__label">{{node.label}}</span>
        </span>
      </el-tree>
    </el-card>
    <el-card class="wrap-form">
      <ButtonList ref="table" :menuCode="currentMenuCode"></ButtonList>
    </el-card>
  </div>
</template>

<script>
import {system} from '../../api'
import ButtonList from './ButtonList'

export default {
  name: 'ButtonManagement',

  components: {
    ButtonList
  },

  mounted () {
    this.initMenuTree()
    this.$bus.$on('ButtonManagement:refreshTable', () => {
      console.log('hahaha')
      this.$refs.table.getTableData()
    })
  },

  destroyed () {
    this.$bus.$off('ButtonManagement:refreshTable')
  },

  data () {
    return {
      fetching: false,
      data: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      defaultExpandedKeys: [],
      currentMenuCode: ''
    }
  },

  methods: {
    async initMenuTree () {
      this.fetching = true
      let {data} = await system.getMenuTree()
      this.fetching = false
      this.data = data
      // 默认展开根节点
      this.defaultExpandedKeys = [data[0].id]
    },
    handleNodeClick (data, node) {
      this.currentMenuCode = data.id
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
}
.wrap-tree {
  width: 280px;
  background-color: white;
  flex-shrink: 0;
}
.wrap-form {
  flex-grow: 1;
  margin-left: 10px;
}
.edit-page {
  position: absolute;
  left: 20px;
  right: 20px;
  top: 20px;
  bottom: 20px;
  z-index: 1;
}

</style>
